<template>
<div class='vx-col w-full'>
    <nav class="menu-navigation-dark">
            <a href="#" v-if="botonera_juego.cabecera" @click="f_click_botonera(1)" :class="op_show==1 ? 'selected' : ''"><i class="fa fa-code"></i><span>Cabecera</span></a>
            <a href="#" v-if="botonera_juego.opciones" @click="f_click_botonera(2)" :class="op_show==2 ? 'selected' : ''"><i class="fa fa-filter"></i><span>Opciones</span></a>
            <a href="#" v-if="botonera_juego.previsualizar" @click="f_click_botonera(3)" :class="op_show==3 ? 'selected' : ''"><i class="fa fa-display"></i><span>Previsualizar</span></a>
            <!-- <a href="#" class="menu-yellow"><i class="fa fa-plane"></i><span>Travel</span></a> -->
            <!-- <a href="#" class="menu-red"><i class="fa fa-heart"></i><span>Favorites</span></a> -->
             <!-- {{ op_show }} -->
        </nav>
</div>
</template>
 
<script>
export default {
    props: {
        botonera_juego: {
            type: Object,
            default: function () {
                return {};
            },
        },
       
    },
        components: {},
        data() {
                return {
                    op_show: 1,
                };
        },
        created() {},
        mounted() {},
        methods: {
            f_click_botonera(item){
                // console.log(item)
                this.op_show = item;
                this.$emit('getClicked_botonera',item)
            }
        }
};
</script>

<style scoped>
.menu-navigation-dark {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0;
    text-align: center;
    margin-top: -10px;
}

.menu-navigation-dark a {
    display: inline-block;
    color: #ffffff;
    background-color: #232526;
    font-size: 25px;
    font-weight: bold;
    box-shadow: 1px 3px 5px 0 rgba(0, 0, 0, 0.26);
    text-transform: uppercase;
    text-decoration: none;
    white-space: nowrap;
    border: 1px solid #161718;
    border-top: none;
    width: 130px;
    margin: 0 auto;
    padding: 10px 0;
    box-sizing: border-box;
}

.menu-navigation-dark a:hover {
    background-color: #27292a;
}

.menu-navigation-dark a:first-child{
    border-left: 1px solid #161718;
}

.menu-navigation-dark a:not(.selected) {
    box-shadow:	1px 3px 5px 0 rgba(0, 0, 0, 0.26),
    inset 1px 0 0 #323435,
    inset 0 1px 0 #282a2b,
    inset 0 -1px 0 #282a2b;
}

.menu-navigation-dark a:last-child {
    box-shadow:	1px 3px 5px 0 rgba(0, 0, 0, 0.26),
    inset 1px 0 0 #323435,
    inset -1px 0 0 #282a2b,
    inset 0 1px 0 #282a2b,
    inset 0 -1px 0 #282a2b;
}

.menu-navigation-dark a i {
    display: block;
    line-height: 1.3;
}

.menu-navigation-dark a span {
    display: block;
    font-size: 11px;
    font-weight: bold;
    line-height: 2;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.menu-navigation-dark a.selected {
    background-color: #1d1e1f;
    border-top: 8px solid #ca0065;
    pointer-events: none;
}

.menu-navigation-dark a.selected i {
    color: #ca0065;
}

/* Make this page responsive */

.slicknav_menu {
    display:none;
}
@media (max-width: 500px) {
    .menu-navigation-dark a.selected {
    background-color: #1d1e1f;
    border: 4px solid #da4a92;
    pointer-events: none;
}

.menu-navigation-dark a.selected i {
    color: #da4a92;
}
}


</style>
